export const getCookieValue = (key) => {
  const fullCookie = document.cookie
    .split(';')
    .find((cookie) => cookie.trim().startsWith(`${key}=`))
  const value = fullCookie?.split('=')[1]
  return value
}

export default { getCookieValue }
